module.exports = __webpack_public_path__ + "img/volumeComparison.c2aff756.png";